import { Bounce, toast } from "react-toastify";
import i18next from "i18next";

const NOTIFICATION_DEDUPE_MS = 5000;
const recentNotifications = new Map<string, number>();

const isDuplicateNotification = (text: string) => {
    const now = Date.now();
    const lastShown = recentNotifications.get(text);

    Array.from(recentNotifications.entries()).forEach(([key, timestamp]) => {
        if (now - timestamp > NOTIFICATION_DEDUPE_MS) {
            recentNotifications.delete(key);
        }
    });

    if (lastShown !== undefined && now - lastShown < NOTIFICATION_DEDUPE_MS) {
        return true;
    }

    recentNotifications.set(text, now);
    return false;
}

export const isLoading = () => window._isLoading();
export const showLoader = () => window._setIsLoading(true);
export const hideLoader = () => window._setIsLoading(false);
export const showAlert = (title: string, text: string) => window._showAlert(title, text);
export const hideAlert = () => window._hideAlert();
export const showDialog = (title: string, text: string, onYes: () => void, onNo: () => void) => window._showDialog(title, text, onYes, onNo);
export const hideDialog = () => window._hideDialog();
export const navigateTo = (to: string) => window._navigateTo(to);

export const showError = (text: string, delay?: number) => {
    text = i18next.t(text);
    if (isDuplicateNotification(text)) {
        return;
    }

    toast.error(text, {
        position: "bottom-center",
        autoClose: delay || 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
    });
}

export const showInfo = (text: string, delay?: number) => {
    toast.info(text, {
        position: "bottom-center",
        autoClose: delay || 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        });
}
